import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button, Form } from 'reactstrap';
import MUIDataTable from "mui-datatables";
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

import {  
    fetchAvailableReport
  
} from 'Actions';

import TestTable from './testtable';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import { RctCardContent } from 'Components/RctCard';

class availableReport extends Component {
   
    constructor(props) {
       
        super(props);          
          
            this.state = {
                seldate:'',
                viewdiv1:false,
                viewdiv2:false,            
                reportdate:'',
            };  

        this.onBackSection = this.onBackSection.bind(this); 
    }

    UNSAFE_componentWillMount() {
        
	}   

    onBackSection(){
        this.setState({ 
            seldate: '',
            viewdiv1:false,
            viewdiv2:false,
        }); 
    }
    


    selectstart = (date) => {  
        this.setState({ 
            viewdiv1:false,
            viewdiv2:false,
        }); 
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        const reptdate =moment(new Date(date)).format('DD-MM-yyyy');
        this.setState({ 
            seldate:date,
            reportdate:reptdate
         });  
        
        this.props.fetchAvailableReport(seldate).then((data) => {              
            var resdata=data.data;
             
            this.setState({ 
                viewdiv1:true,
                viewdiv2:true,
            });              
            
         });        

    }
   
    
    render() {
        const { match, studentsavailable, loading } = this.props;       
        var studentlist=[];
        if(studentsavailable.length==0){
            
        }else{
            studentlist=studentsavailable.availablestudent;
        }
        

        const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            responsive:'standard',
            downloadOptions:{'filename':'Student Available Report - '+this.state.reportdate, 'header':'tested'}
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "checkouttime", label: "CHECK-OUT-TIME" },
            { name: "checkintime", label: "CHECK-IN-TIME" },
          
        ];
        const tabledata=studentlist.map((assmntval,idx) => {  
               
                return {
                    no:idx+1,
                    name: assmntval.student,
                    checkouttime: assmntval.checkouttime,
                    checkintime: assmntval.checkintime,
                
                }
        });

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Students Available Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Travel" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.studentavailable" />} match={match} />

                <div className="row">
                        <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}>
                            <RctCollapsibleCard> 
                                    <div className="row">                                        
                                        <div className="col-sm-12 col-lg-10" style={{margin:"0 auto"}}> 
                                                <FormGroup>
                                                    <Label for="Select">Select Date</Label>
                                                    <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectstart}
                                                        dateFormat='yyyy-MM-dd '
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                    /> 
                                                </FormGroup>
                                        </div> 
                                    </div>
                            </RctCollapsibleCard>  
                        </div>
                </div>


                {this.state.viewdiv1 && 
                    <div className="row">
                            <div className="col-sm-12 col-lg-3">
                                <div className="current-widget bg-success">
                                    <RctCardContent>
                                        <div className="d-flex justify-content-between">
                                            <div className="align-items-start" style={{margin:"0 auto"}}>
                                                <h3 className="mb-10">On Campus</h3>
                                                <h2 className="mb-0" style={{textAlign:"center"}}>{studentsavailable.totaloncampus}</h2>
                                            </div>
                                            
                                        </div>
                                    </RctCardContent>
                                </div>
                            </div>
                            <div className="col-sm-12 col-lg-3">
                                <div className="current-widget bg-danger">
                                    <RctCardContent>
                                        <div className="d-flex justify-content-between">
                                            <div className="align-items-start" style={{margin:"0 auto"}}>
                                                <h3 className="mb-10">Travel</h3>
                                                <h2 className="mb-0" style={{textAlign:"center"}}>{studentsavailable.totaltravel}</h2>
                                            </div>
                                            
                                        </div>
                                    </RctCardContent>
                                </div>
                            </div>
                            <div className="col-sm-12 col-lg-3">
                                <div className="current-widget bg-info">
                                    <RctCardContent>
                                        <div className="d-flex justify-content-between">
                                            <div className="align-items-start" style={{margin:"0 auto"}}>
                                                <h3 className="mb-10">Contract Student</h3>
                                                <h2 className="mb-0" style={{textAlign:"center"}}>{studentsavailable.totalgolfer}</h2>
                                            </div>
                                            
                                        </div>
                                    </RctCardContent>
                                </div>
                            </div>
                            <div className="col-sm-12 col-lg-3">
                                <div className="current-widget bg-warning">
                                    <RctCardContent>
                                        <div className="d-flex justify-content-between">
                                            <div className="align-items-start" style={{margin:"0 auto"}}>
                                                <h3 className="mb-10">Visiting Students</h3>
                                                <h2 className="mb-0" style={{textAlign:"center"}}>{studentsavailable.totalvistors}</h2>
                                            </div>
                                            
                                        </div>
                                    </RctCardContent>
                                </div>
                            </div>
                    </div>
                }  

                {this.state.viewdiv2 &&
                  <TestTable data={this.state}/>
                }               
            
          </div>
       )
    }
 }
 
 const mapStateToProps = ({ visitors  }) => {
    const { studentsavailable, loading } = visitors;
	return { studentsavailable, loading };
}

export default connect(mapStateToProps, {
    fetchAvailableReport
})(availableReport); 